/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : hightman (hightman@cloud-sun.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import * as commonApi from '@/api/common';
import { USER } from '@/store/types';
import { UserAccount } from '@/api/types/user';
import { WxTransferAuthState } from '@/api/types/common';
import store from '..';

export interface StoreUserAccountState {
  list: UserAccount[];
  maxLimit: number;
  transferAuth: WxTransferAuthState | null;
}

export default {
  namespaced: true,
  state: {
    list: [],
    maxLimit: 0,
    transferAuth: null,
  },
  getters: {},
  actions: {
    [USER.GET_ACCOUNTS]({ commit, state }, { reload = false } = {}) {
      if (state.maxLimit === 0 || reload) {
        return new Promise<void>((resolve, reject) => {
          api.getAccounts([400]).then((res) => {
            commit(USER.GET_ACCOUNTS, {
              list: res.data,
              maxLimit: res.extra?.maxLimit,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [USER.GET_WX_TRANSFER_AUTH]({ commit }) {
      return new Promise<void>((resolve, reject) => {
        commonApi.getWxTransferAuth([400]).then((res) => {
          commit(USER.GET_WX_TRANSFER_AUTH, res.data);
          resolve();
        }).catch((err) => {
          if (err.response && err.response.errcode === 400) {
            commit(USER.GET_WX_TRANSFER_AUTH, null);
            resolve();
          } else {
            reject(err);
          }
        });
      });
    },
    [USER.CREATE_ACCOUNT](_, { phone, code }) {
      return new Promise<void>((resolve, reject) => {
        api.createAccount(phone, code).then(() => {
          store.dispatch(`user/${USER.GET}`, { action: 'reload', silent: true }).finally(resolve);
        }).catch(reject);
      });
    },
    [USER.SET_ACCOUNT](_, { xid }) {
      return new Promise<void>((resolve, reject) => {
        api.setAccount(xid).then(() => {
          store.dispatch(`user/${USER.GET}`, { action: 'reload', silent: true }).finally(resolve);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_ACCOUNTS](state, { list, maxLimit }) {
      state.list = list;
      state.maxLimit = maxLimit || 0;
    },
    [USER.GET_WX_TRANSFER_AUTH](state, transferAuth) {
      state.transferAuth = transferAuth;
    },
  },
};
